export const PREMIUM_PLANS = [
  {
    value: "monthly",
    title: "US$9",
    subtitle: "/month",
  },
  {
    value: "yearly",
    title: "US$99",
    subtitle: "/year",
  },
];
